<template>
  <div class="person-appointment-list">
    <div slot="title" class="mb-5">
      <h4>
        {{title}}
      </h4>
    </div>

    <v-server-table
      :columns="tableColumns"
      :options="tableOptions"
      @row-click="click => $emit('row-click', {appointment: click.row})"
      id="appointmentsTable"
      ref="appointmentsTable"
      name="appointmentsTable"
    >

      <span slot="h__icon"></span>

      <span slot="h__observations"></span>

      <span slot="icon" slot-scope="{row}">
        <va-popover
          :message="row.parent_id === null ? $t('clinical.appointments.appointment') : $t('evocall.requests.request')"
          placement="left"
        >
          <i class="appointment-list-icon" :class="{'i-waiting-room-appointment': row.parent_id === null, 'i-waiting-room-call-request': row.parent_id !== null}"></i>
        </va-popover>
      </span>

      <span slot="start" slot-scope="{row}">
        <span>{{ moment(row.start).format('DD/MM/YYYY') }}</span>
      </span>

      <span slot="start_time" slot-scope="{row}">
        <span>{{ moment(row.start).format('HH:mm') }}</span>
      </span>

      <span slot="location" slot-scope="{row}">
        <span>{{ row.facility ? row.facility.name : row.entity.name }}</span>
      </span>

      <span slot="type" slot-scope="{row}">
        <span v-if="row.parent_id === null && row.type !== null">
          {{ getAppointmentTypeLabel(row.type) }}
        </span>
        <span v-if="row.parent_id !== null && row.call_type_id !== null"> {{ $t(`evocall.types.${row.call_type_id}`) }}</span>
      </span>

      <span slot="observations" slot-scope="{row}">
        <va-popover
          v-if="row.obs !== null"
          :message="row.obs"
          placement="left"
        >
          <i class="appointment-list-icon i-has-comment-gray"></i>
        </va-popover>
      </span>

    </v-server-table>

  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    person: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    options: {
      type: Object,
      required: false
    },
    showObservations: {
      type: Boolean,
      required: false,
      default: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  mixins: [
    TableQueryMixin
  ],
  data () {
    return {
      tableOptions: {
        filterable: false,
        saveState: false,
        columnsDropdown: false,
        sortable: ['start'],
        responseAdapter: function (response) {
          let data = this.getResponseData(response)
          const appointments = data.data.map(appointment => {
            return {
              ...appointment,
              start: this.$options.filters.localTime(appointment.start),
              end: this.$options.filters.localTime(appointment.end)
            }
          })

          return {
            data: appointments,
            count: data.count
          }
        },
        headings: {
          start: this.$t('tables.columns.date'),
          start_time: this.$t('tables.columns.time'),
          location: this.$t('tables.columns.local'),
          type: this.$t('clinical.appointments.type')
        },
        columnsClasses: {
          icon: 'appointment-parent-type',
          date: 'date',
          time: 'time',
          observations: 'observations'
        },
        orderBy: {
          column: this.options.orderBy && this.options.orderBy.hasOwnProperty('column') ? this.options.orderBy.column : 'start',
          ascending: this.options.orderBy && this.options.orderBy.hasOwnProperty('ascending') ? this.options.orderBy.ascending : false
        }
      }
    }
  },
  methods: {
    getAppointmentTypeLabel: function (appointmentType) {
      if (!appointmentType) return 'N/A'
      let label = appointmentType.name
      if (appointmentType.slug && label !== appointmentType.slug) {
        label += ` (${appointmentType.slug})`
      }
      return label
    },
    reloadTable: function () {
      this.$refs.appointmentsTable.refresh()
    }
  },
  computed: {
    tableColumns: function () {
      let columns = ['icon', 'start', 'start_time', 'location', 'type']
      if (this.showObservations) {
        columns.push('observations')
      }
      return columns
    },
    queryUrl: function () {
      let params = ''
      if (this.params !== undefined) {
        Object.keys(this.params).forEach((key, index) => {
          params = `${params}${index === 0 ? '?' : '&'}${key}=${this.params[key]}`
        })
      }
      return `${this.service.url}/admin/people/${this.person.id}/appointments${params}`
    },
  },
  watch: {
    queryUrl: function () {
      this.$refs.appointmentsTable.refresh()
    }
  }
}
</script>
<style lang="scss">
.person-appointment-list {

  .VueTables.VueTables--server {
    margin-top: 0;
  }

  #appointmentsTable {

    i {
      display: block;
      width: 1.5rem;
      height: 1.5rem;
    }

    td {
      vertical-align: middle !important;
    }

    th.observations, td.observations{
      width: 10%;
      text-align: center;
    }

    th.appointment-parent-type, td.appointment-parent-type {
      width: 7.5%;
      text-align: center;
    }

    $assetsPath: "../../../../assets";
    @import '@/sass/icons/icons-classes.scss';

    tr:hover {
      .i-waiting-room-appointment {
        @extend .i-waiting-room-appointment-white;
      }
      .i-waiting-room-call-request {
        @extend .i-waiting-room-call-request-white;
      }

      .i-has-comment-gray {
        @extend .i-has-comment-white;
      }
    }
  }
}

</style>
